import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from 'react';
import { Command as CommandPrimitive } from 'cmdk';
import { cn } from '@discover-lib/utils';

export type CommandListProps = ComponentPropsWithoutRef<typeof CommandPrimitive.List>;

const CommandList = forwardRef<ElementRef<typeof CommandPrimitive.List>, CommandListProps>(
  ({ className, ...props }, ref) => (
    <CommandPrimitive.List
      ref={ref}
      className={cn('max-h-[300px] overflow-y-auto overflow-x-hidden', className)}
      {...props}
    />
  )
);

CommandList.displayName = CommandPrimitive.List.displayName;

export default CommandList;
